module.exports = __webpack_public_path__ + "img/teaser_240x200_injoyleibnitz.f4f326ec.jpg";